/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR Code Generator (Free, Downloadable PNG) — Toolverse`)
};

const es_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Códigos QR (Gratis, PNG Descargable) — Toolverse`)
};

const de_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code-Generator (kostenlos, als PNG herunterladbar) — Toolverse`)
};

const nl_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-code Generator (Gratis, Downloadbare PNG) — Toolverse`)
};

const fr_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de QR Code (Gratuit, PNG Téléchargeable) — Toolverse`)
};

const it_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di codici QR (gratuito, PNG scaricabile) — Toolverse`)
};

const pt_br2_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Código QR (Grátis, PNG para Baixar) — Toolverse`)
};

const pt_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Código QR (Gratuito, PNG Descarregável) — Toolverse`)
};

const ja_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QRコード生成ツール(無料、PNGダウンロード対応) — Toolverse`)
};

const zh_qr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二维码生成器（免费，可下载 PNG）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_meta_title", locale)
	if (locale === "en") return en_qr_meta_title(inputs)
	if (locale === "es") return es_qr_meta_title(inputs)
	if (locale === "de") return de_qr_meta_title(inputs)
	if (locale === "nl") return nl_qr_meta_title(inputs)
	if (locale === "fr") return fr_qr_meta_title(inputs)
	if (locale === "it") return it_qr_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_qr_meta_title(inputs)
	if (locale === "pt") return pt_qr_meta_title(inputs)
	if (locale === "ja") return ja_qr_meta_title(inputs)
	return zh_qr_meta_title(inputs)
};